module.exports = __webpack_public_path__ + "img/last-dance-logo.6c725d3c.png";